import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

import { getAppConfig } from '../context/AppConfigContext';
import logger from '../utils/logger';
import logError from '../utils/logError';

const { cognito } = getAppConfig();
const awsRegion = cognito.region;
const identityPoolId = cognito.identityPoolId;

export const userPool = new CognitoUserPool({
  UserPoolId: cognito.userPoolId,
  ClientId: cognito.clientId,
});

export function decodeJWT(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
  return JSON.parse(jsonPayload);
}

export async function logoutServer(authBaseUrl) {
  const csrfToken = localStorage.getItem('csrfToken');
  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'X-CSRF-Token': csrfToken,
  };

  try {
    if (!authBaseUrl) {
      console.error('Missing auth base URL for logout');
      return;
    }
    const logoutResponse = await fetch(`${authBaseUrl}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers,
    });

    if (logoutResponse.status === 400) {
      logger.error(logError(new Error('Logout failed: Bad request')));
    } else if (logoutResponse.status === 500) {
      logger.error(logError(new Error('Logout failed: Internal server error')));
    } else if (logoutResponse.ok) {
      logger.info('Logout successful');
    } else {
      const error = await logoutResponse.json();
      logger.error(logError(error, { action: 'logoutServer' }));
    }
  } catch (error) {
    logger.error(logError(error, { action: 'logoutServer' }));
  }
}

export async function getPreSignedUrl(url, idToken) {
  try {
    const { hostname, pathname } = new URL(url);
    const bucketName = hostname.split('.')[0];
    const fileName = pathname.substring(1);

    const s3Client = new S3Client({
      region: awsRegion,
      credentials: fromCognitoIdentityPool({
        clientConfig: { region: awsRegion },
        identityPoolId,
        logins: {
          [`cognito-idp.${awsRegion}.amazonaws.com/${cognito.userPoolId}`]: idToken,
        },
      }),
    });

    const command = new GetObjectCommand({ Bucket: bucketName, Key: fileName });
    return await getSignedUrl(s3Client, command, { expiresIn: 60 });
  } catch (err) {
    logger.error(logError(err, { action: 'getPreSignedUrl' }));
    throw err;
  }
}
